<!-- 如何参与 -->
<template>
  <div class="how-participate">
    <h1 class="my-title">
      <div>
        <span>如何</span>
        <strong>参与活动</strong>
      </div>
    </h1>
    <ul>
      <div class="hidden-sm-and-down">
        <div class="liStyle">
          <li v-for="item in partlist" :key="item.id" :class="[item.id < 10 ? 'step' : 'jt']">
            <template v-if="item.id < 10">
              <p>STEP {{ item.id }}</p>
              <span>{{ item.title }}</span>
              <div v-html="item.desc"></div>
              <b @click="handleJump(item.id)" v-show="item.go">{{ item.go }}</b>
            </template>
            <img v-else src="@/assets/images/24students/icon-jt.svg" alt="" />
          </li>
        </div>
      </div>

      <div class="hidden-sm-and-up">
        <!-- <div class="my-title">
          <h1>
            <div>仅需几步，</div>
            轻松携号转网
          </h1>
        </div> -->
        <div class="liStyle">
          <template v-for="item in partlistH5">
            <div class="line" v-if="[12, 13, 14].includes(item.id)" :key="item.id"></div>
            <li v-else :key="item.title">
              <div>
                <p>STEP {{ item.id }}</p>
                <span>{{ item.title }}</span>
                <strong v-html="item.desc"></strong>
              </div>
              <b @click="handleJump(item.id)" v-show="item.go">{{ item.go }}</b>
            </li>
          </template>
        </div>
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      partlist: [
        {
          id: 1,
          title: '购买优惠券',
          desc: '用户通过Visa中国权益平台，购买Visa用户专享优惠券',
          go: ''
        },
        { id: 12 },
        {
          id: 2,
          title: '使用折扣码购买套餐',
          desc: '点击进入ENC Visa活动页，根据页面提示购买套餐，在优惠信息栏填写您的专属折扣码',
          go: '去使用 >'
        },
        { id: 23 },
        {
          id: 3,
          title: '物流寄送',
          desc: '<b class="weight">实体卡：</b>等待物流寄送，支持中国、美国两地免费寄送<br /><b class="weight">eSIM卡：</b>使用前去激活，无需等待寄送。',
          go: '去查询 >'
        },
        { id: 15 },
        {
          id: 4,
          title: '激活手机卡',
          desc: '使用前登入激活页面，激活您的手机卡，eSIM卡激活成功后根据提示扫码安装后即可使用。',
          go: '去激活 >'
        }
      ],
      partlistH5: [
        {
          id: 1,
          title: '购买优惠券',
          desc: '用户通过Visa中国权益平台，购买Visa用户专享优惠券',
          go: ''
        },
        { id: 12 },
        {
          id: 2,
          title: '使用折扣码购买套餐',
          desc: '点击进入ENC Visa活动页，根据页面提示购买套餐，在优惠信息栏填写您的专属折扣码',
          go: '去使用 >'
        },
        { id: 13 },
        {
          id: 3,
          title: '物流寄送',
          desc: '<b class="weight">实体卡：</b>等待物流寄送，支持中国、美国两地免费寄送<br /><b class="weight">eSIM卡：</b>使用前去激活，无需等待寄送。',
          go: '去查询 >'
        },
        { id: 14 },
        {
          id: 4,
          title: '激活手机卡',
          desc: '使用前登入激活页面，激活您的手机卡，eSIM卡激活成功后根据提示扫码安装后即可使用。',
          go: '去激活 >'
        }
      ]
    };
  },
  methods: {
    handleJump(val) {
      const dom = document.querySelector('.package-info');
      switch (val) {
        case 1:
          if (dom) {
            dom.scrollIntoView({ behavior: 'smooth' });
          }
          break;
        case 2:
          if (dom) {
            dom.scrollIntoView({ behavior: 'smooth' });
          }
          break;

        case 3:
          window.open('https://www.encmobile.com/tracking/search', '_blank');
          break;

        case 4:
          window.open('https://www.encmobile.com/activation/first', '_blank');
          break;

        default:
          break;
      }
    }
  }
};
</script>
<style scoped lang="less">
.how-participate {
  width: 1200px;
  margin: 0 auto 80px;

  ul {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding: 40px;
    box-sizing: border-box;
    border-radius: 16px;
    background: #07a34f;
    box-shadow: 0px 7px 20px 0px rgba(130, 214, 184, 0.48);
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;

      .liStyle {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        li {
          height: 100%;
          display: flex;
          flex-direction: column;

          p {
            color: #fff;
            font-family: OPPOSans;
            font-size: 32px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin-bottom: 8px;
          }
          span {
            color: #fff;
            font-family: OPPOSans;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            text-wrap: nowrap;
          }
          div {
            color: rgba(255, 255, 255, 0.75);
            font-family: OPPOSans;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px; /* 133.333% */
            display: block;
            height: 100px;
            text-align: left;
            margin: 16px 0;
            ::v-deep .weight {
              font-weight: 600;
              color: rgba(255, 255, 255, 1);
            }
          }
          b {
            width: 120px;
            padding: 8px 12px;
            text-align: center;
            color: #ce8917;
            font-family: OPPOSans;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            cursor: pointer;
            border-radius: 400px;
            background: #fff;
          }
        }
        .jt {
          margin: 32px 24px 0;
          img {
            width: 32px;
            height: 32px;
          }
        }
        .step {
          width: calc(25% - 60px);
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .how-participate {
    width: 100vw;
    flex-direction: column;
    box-sizing: border-box;
    gap: 0px;
    margin: 0 auto;
    img {
      width: 39.4667vw;
      height: 10.6667vw;
    }
    .my-title {
      margin-bottom: 0 !important;
    }

    ul {
      width: 100%;
      padding: 10vw 7vw /* 30px -> 4vw */;
      > div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 10px;
        width: 100%;
        .my-title {
          display: flex;
          position: relative;
          h1 {
            color: #fff;
            font-family: OPPOSans;
            font-size: 4.8667vw /* 32px -> 4.2667vw */;
            font-style: normal;
            font-weight: 600;
            line-height: 8.5333vw /* 64px -> 8.5333vw */;
            position: relative;
            z-index: 1;
            div {
              color: #000000;
              font-family: OPPOSans;
              font-size: 4.8667vw /* 32px -> 4.2667vw */;
              font-style: initial;
              font-weight: 600;
              line-height: 8.5333vw /* 64px -> 8.5333vw */;
              position: relative;
              z-index: 1;
            }
            &::after {
              content: '';
              position: absolute;
              right: -3.8vw /* -6px -> -0.8vw */;
              top: -0.8667vw /* 1px -> .1333vw */;
              background: url(~@/assets/images/portin/title1-b.svg) no-repeat;
              background-size: 100% 100%;
              width: 4vw /* 30px -> 4vw */;
              height: 4vw /* 30px -> 4vw */;
            }

            &::before {
              content: '';
              position: absolute;
              right: -2.2vw /* 6px -> .8vw */;
              bottom: 1.8667vw /* 14px -> 1.8667vw */;
              background: url(~@/assets/images/portin/title2-b.svg) no-repeat;
              background-size: 100% 100%;
              width: 1.7333vw /* 13px -> 1.7333vw */;
              height: 1.7333vw /* 13px -> 1.7333vw */;
            }
          }
          &::after {
            content: '';
            position: absolute;
            top: 0vw /* 11px -> 1.4667vw */;
            left: -5vw /* 15px -> 2vw */;
            background: url(~@/assets/images/portin/title.svg) no-repeat;
            background-size: 100% 100%;
            width: 26.4667vw /* 116px -> 15.4667vw */;
            height: 9.2667vw /* 47px -> 6.2667vw */;
            z-index: 0;
          }
        }
        .liStyle {
          width: 100%;
          justify-content: space-between;
          align-items: flex-start;
          flex-direction: column;
          li {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            > div {
              width: 80%;
              height: auto;
              p {
                color: #fff;
                font-family: OPPOSans;
                font-size: 4.2667vw;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }
              strong {
                display: block;
                color: rgba(255, 255, 255, 0.85);
                font-family: OPPOSans;
                font-size: 3.2vw;
                font-style: normal;
                font-weight: 400;
                line-height: 4.2667vw; /* 133.333% */
                height: auto;
                display: block;
                width: 62.4vw;
                margin: 2.1333vw 0;
              }
            }
            img {
              width: 8vw;
              height: 8vw;
            }
            .jt {
              display: none;
            }

            span {
              color: #fff;
              font-family: 'PingFang SC';
              font-size: 3.7333vw;
              font-style: normal;
              font-weight: 600;
              line-height: normal;
            }

            b {
              width: auto;
              color: #ffe271;
              font-family: OPPOSans;
              font-size: 4.2667vw;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              text-decoration-line: underline;
              background: none;
              padding: 0;
            }
          }
        }
        .line {
          width: 100%;
          border: 1px dashed #fff;
          height: 1;
          transform: scaleY(-0.2);
        }
      }
    }
  }
}
</style>
